import Home01Icon from "@hugeicons/core-free-icons/Home01Icon";
import RepeatIcon from "@hugeicons/core-free-icons/RepeatIcon";
import PackageProcessIcon from "@hugeicons/core-free-icons/PackageProcessIcon";
import Invoice01Icon from "@hugeicons/core-free-icons/Invoice01Icon";
import Clock01Icon from "@hugeicons/core-free-icons/Clock01Icon";
import DeliveryTruck01Icon from "@hugeicons/core-free-icons/DeliveryTruck01Icon";
import UserMultipleIcon from "@hugeicons/core-free-icons/UserMultipleIcon";
import Table01Icon from "@hugeicons/core-free-icons/Table01Icon";
import Alert02Icon from "@hugeicons/core-free-icons/Alert02Icon";
import InjectionIcon from "@hugeicons/core-free-icons/InjectionIcon";
import ShoppingCartCheck01Icon from "@hugeicons/core-free-icons/ShoppingCartCheck01Icon";
import { OPS_ROLES } from "../constants/roles";

// Ops Console nav. Every section is a real /v2/ops route — the sidebar no longer
// deep-links out to the legacy pages. Those pages are untouched and still reachable at
// their own URLs (/all-orders, /quotations, /partner-orders, /future-orders); this
// console is additive.
//
// All entries share OPS_ROLES, the same list the routes are gated with, so a visible
// nav item can never lead somewhere the user is bounced from.
export const OPS_NAV = [
    { key: "overview", label: "Overview", path: "/v2/ops/overview", icon: Home01Icon, roles: OPS_ROLES },
    { key: "reorders", label: "Reorders", path: "/v2/ops/reorders", icon: RepeatIcon, roles: OPS_ROLES },
    { key: "orders", label: "Orders", path: "/v2/ops/orders", icon: PackageProcessIcon, roles: OPS_ROLES },
    { key: "quotations", label: "Quotations", path: "/v2/ops/quotations", icon: Invoice01Icon, roles: OPS_ROLES },
    { key: "tat", label: "TAT Dashboard", path: "/v2/ops/tat", icon: Clock01Icon, roles: OPS_ROLES },
    { key: "b2b", label: "B2B", path: "/v2/ops/b2b", icon: DeliveryTruck01Icon, roles: OPS_ROLES },
    // Order Tracking Sheet — the legacy /order-tracking-sheet screen, reused as-is.
    { key: "tracking-sheet", label: "Order Tracking Sheet", path: "/v2/ops/tracking-sheet", icon: Table01Icon, roles: OPS_ROLES },
    { key: "action-needed", label: "Action Needed", path: "/v2/ops/action-needed", icon: Alert02Icon, roles: OPS_ROLES },
    { key: "glp1", label: "GLP-1 Dashboard", path: "/v2/ops/glp1", icon: InjectionIcon, roles: OPS_ROLES },
    { key: "self-checkout", label: "Self-Checkout Dashboard", path: "/v2/ops/self-checkout", icon: ShoppingCartCheck01Icon, roles: OPS_ROLES },
    // Users — the legacy /users screen, reused as-is (see routes.jsx).
    { key: "users", label: "Users", path: "/v2/ops/users", icon: UserMultipleIcon, roles: OPS_ROLES },
];
